import { COMPONENT_PRODUCTBUYBUTTON_QUANTITY_DEFAULTS } from '@/constants'

function toPositiveInt (value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const parsed = Number(value)
  if (!Number.isFinite(parsed)) {
    return null
  }

  const truncated = Math.trunc(parsed)
  return truncated > 0 ? truncated : null
}

export function resolveOrderQuantityInfo (minimumOrderQuantity, orderInterval) {
  const hasInterval = toPositiveInt(orderInterval) != null
  const hasMinimum = toPositiveInt(minimumOrderQuantity) != null
  const step = hasInterval ? toPositiveInt(orderInterval) : COMPONENT_PRODUCTBUYBUTTON_QUANTITY_DEFAULTS.step
  const min = hasMinimum
    ? toPositiveInt(minimumOrderQuantity)
    : (hasInterval ? toPositiveInt(orderInterval) : COMPONENT_PRODUCTBUYBUTTON_QUANTITY_DEFAULTS.min)

  return {
    min,
    max: COMPONENT_PRODUCTBUYBUTTON_QUANTITY_DEFAULTS.max,
    step,
    initialStep: COMPONENT_PRODUCTBUYBUTTON_QUANTITY_DEFAULTS.initialStep
  }
}

export function resolveOrderQuantityInfoFromProduct (product = {}) {
  return resolveOrderQuantityInfo(
    product.minimumOrderQuantity ?? product.MinimumOrderQuantity,
    product.orderInterval ?? product.OrderInterval
  )
}
